import { Switch, Route, useRouteMatch } from 'react-router-dom';
import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';
import { ErrorBoundary } from '@/app/ui/error';

const ListComponent = LoadComponentWithRetry(() => import('./ListEstimatePage'));
const AddComponent = LoadComponentWithRetry(() => import('./AddEstimateRoutes'));
const ConsolidatedComponent = LoadComponentWithRetry(() => import('./AddConsolidatedEstimatePage'));
const ViewComponent = LoadComponentWithRetry(() => import('./ViewEstimatePage'));
const DuplicateComponent = LoadComponentWithRetry(() => import('./DuplicateEstimateRoutes'));
const ImportFromTogalComponent = LoadComponentWithRetry(() => import('@/app/togalIntegration/ViewImportFromTogalPage'));
const ImportFromBuildingConnectedComponent = LoadComponentWithRetry(() => import('@/app/buildingConnectedIntegration/ViewImportFromBuildingConnectedPage'));
const ViewEstimateReportComponent = LoadComponentWithRetry(() => import('@/app/estimateReport/ViewEstimateReportPageForEstimate'));
const ViewPlanSheetWalkthroughComponent = LoadComponentWithRetry(() => import('@/app/planSheetWalkthrough/ViewPlanSheetWalkthroughPage'));

const Routes = () => {
  const { path } = useRouteMatch();
  return (
    <ErrorBoundary>
      <Switch>
        <Route path={`${path}/add/consolidated`} component={ConsolidatedComponent} />
        <Route path={`${path}/add`} component={AddComponent} />
        <Route path={`${path}/duplicate`} component={DuplicateComponent} />
        <Route path={`${path}/:estimateUid/estimate-report/:estimateReportUid`} component={ViewEstimateReportComponent} />
        {/* The plan sheet viewer, under the Drawings list: a sheet, or the walkthroughs. */}
        <Route
          path={[`${path}/:estimateUid/document/drawings/:planSheetDocumentUid/walkthroughs`, `${path}/:estimateUid/document/drawings/:planSheetUid`]}
          component={ViewPlanSheetWalkthroughComponent}
        />
        <Route path={`${path}/:estimateUid/import-from-togal`} component={ImportFromTogalComponent} />
        <Route path={`${path}/:estimateUid/import-from-bc/:bidPackageUid`} component={ImportFromBuildingConnectedComponent} />
        <Route path={`${path}/:estimateUid`} component={ViewComponent} />
        <Route path={path} component={ListComponent} />
      </Switch>
    </ErrorBoundary>
  );
};

export default Routes;
